import { useState, useRef, useCallback } from "react";

export function useTourAPI() {
  const [tourItems, setTourItems] = useState([]);
  const [tourError, setTourError] = useState("");
  const [tourLoading, setTourLoading] = useState(false);
  const [tourLoaded, setTourLoaded] = useState({ festival: false, tourist: false, food: false });
  const tourLoadedRef = useRef({ festival: false, tourist: false, food: false });

  const tourMapPins = (Array.isArray(tourItems) ? tourItems : [])
    .map(item => {
      if (
        item?.mapy == null || item?.mapx == null ||
        String(item.mapy).trim() === "" || String(item.mapx).trim() === ""
      ) return null;
      const lat = Number(item.mapy); // TourAPI mapy = 위도
      const lng = Number(item.mapx); // TourAPI mapx = 경도
      if (
        !Number.isFinite(lat) || !Number.isFinite(lng) ||
        Math.abs(lat) > 90 || Math.abs(lng) > 180 ||
        (lat === 0 && lng === 0)
      ) return null;
      return {
        lat,
        lng,
        title: item.title || item.name || "",
        addr: item.addr1 || "",
        img: item.firstimage || "",
      };
    })
    .filter(Boolean);

  const fetchTourAPI = useCallback(async (tabKey) => {
    if (tourLoadedRef.current[tabKey]) return;
    tourLoadedRef.current[tabKey] = true;
    setTourLoading(true);
    setTourError("");
    try {
      const res = await fetch(`/api/tourapi?tabKey=${encodeURIComponent(tabKey)}`, {
        headers: { Accept: "application/json" },
      });
      if (!res.ok) throw new Error(`TourAPI HTTP ${res.status}`);
      const data = await res.json();
      const list = data.items || [];
      setTourItems(Array.isArray(list) ? list : []);
      setTourLoaded(prev => ({ ...prev, [tabKey]: true }));
    } catch (e) {
      const safe = (e.message || "").replace(/serviceKey=[^&]*/g, "serviceKey=***");
      console.error("TourAPI 로드 실패:", safe || e);
      setTourError(safe || "관광 정보를 불러오지 못했습니다.");
      tourLoadedRef.current[tabKey] = false;
      setTourLoaded(prev => ({ ...prev, [tabKey]: false }));
    } finally {
      setTourLoading(false);
    }
  }, []);

  return {
    tourItems, setTourItems, tourError, setTourError,
    tourLoading, setTourLoading,
    tourLoaded, setTourLoaded, tourLoadedRef, tourMapPins, fetchTourAPI,
  };
}
